'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = require('scrollmonitor');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scrollmonitor/build/scrollMonitorClient.js
 ** module id = 808
 ** module chunks = 0
 **/